import {AnyFieldApi} from '@tanstack/form-core';
import {EvDatepicker} from '../ev-datepicker/ev-datepicker';

interface Props {
  title?: string;
  formStyle?: 'sm' | null | undefined;
  field: AnyFieldApi;
  className?: string;
  disabled?: boolean | null | undefined;
  id?: string;
}

export function EvDatePickerField(props: Props) {
  return <EvDatepicker id={props.id ?? props.field.name}
                       title={props.title}
                       name={props.field.name}
                       inputClassName={props.className}
                       value={props.field.state.value ?? ''}
                       disabled={props.disabled}
                       onChange={(dateString) => props.field.handleChange(dateString)}
                       onBlur={props.field.handleBlur}
                       onFocus={props.field.handleBlur}
                       formStyle={props.formStyle} />;
}
